import { Injectable } from '@angular/core';
import { SsoHint, SsoHintUtility, SSO_HINT_PARAM } from '@jms/model';

@Injectable({ providedIn: 'root' })
export class UtilService {
  constructor() { }

  // Build the redirect params that carry a tenant's advanced SSO hint to the shared id app.
  // Returns an empty object for standard tenants (no hint), so it can be spread into navigate().
  public static ssoHintParams(hint?: SsoHint | null): Record<string, string> {

    const encoded = SsoHintUtility.encode(hint);
    return encoded ? { [SSO_HINT_PARAM]: encoded } : {};
  }

  public static getLocation(href = ''): any {
    if (!href) href = UtilService.getWindowHref();

    const match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return (
      match && {
        href: href,
        protocol: match[1],
        host: match[2],
        hostName: match[3],
        port: match[4],
        pathName: match[5],
        search: match[6],
        hash: match[7]
      }
    );
  }

  public static getURLParameter(name, url = '') {
    if (!url) {
      url = UtilService.getWindowHref();
    }

    return (RegExp(name + '=' + '(.+?)(&|$)').exec(url) || [, null])[1];
  }

  public static getFullURLParameter(url = '') {
    if (!url) {
      url = UtilService.getWindowHref();
    }

    const index = url.indexOf('?');
    if (index >= 0) {
      return url.substring(index);
    }
    return url;
  }

  public static getWindowHref() {
    return UtilService.getWindow().location.href;
  }

  public static getWindow(): Window {
    return window as Window;
  }

  public static getDocument() {
    return document;
  }

  public static navigate(url: string, callbackUrl = '', extraParams: Record<string, string> = {}) {
    const w = UtilService.getWindow();

    const params: string[] = [];

    if (callbackUrl) {
      params.push(`returnUrl=${encodeURIComponent(callbackUrl)}`);
    }

    Object.keys(extraParams).forEach(key => {
      const value = extraParams[key];
      if (value) {
        params.push(`${key}=${encodeURIComponent(value)}`);
      }
    });

    if (params.length) {
      url = `${url}?${params.join('&')}`;
    }

    w.location.href = url;
  }

  public static navigateWithParams(url, params: any = null) {
    const w = UtilService.getWindow();

    if (params) {
      const keys = Object.keys(params);
      const query = keys
        .map(p => {
          return `${p}=${params[p]}`;
        })
        .join();
      url = `${url}?${query}`;
    }

    w.location.href = url;
  }

  public static printImage(url: string): void {

    const content = '<html xmlns="http://www.w3.org/1999/xhtml" lang="en" xml:lang="en">' +
      '<head></head>' +
      '<body><img id="print-image-element" src="' + url + '"/>' +
      '<script type="text/javascript">function printPage() { window.focus(); window.print(); return; }</script>' +
      '</body></html>';

    const newIframe = document.createElement('iframe') as any;
    newIframe.width = '0';
    newIframe.height = '0';
    newIframe.src = 'about:blank';
    document.body.appendChild(newIframe);

    newIframe.contentWindow['contents'] = content;
    newIframe.src = 'javascript:window["contents"]';

    newIframe.focus();

    newIframe.onload = function () {
      newIframe.contentWindow.printPage();
    }
  }
}
